import React from 'react';
import '../styles/CustomMeetingRoom.css'
export default function StudentProfile({ studentDetails }) {
  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h2 className="text-2xl font-semibold mb-4">My Profile</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-gray-600">Name</p>
          <p className="font-semibold">{studentDetails.full_name}</p>
        </div>
        <div>
          <p className="text-gray-600">Email</p>
          <p className="font-semibold">{studentDetails.email}</p>
        </div>
        <div>
          <p className="text-gray-600">Phone Number</p>
          <p className="font-semibold">{studentDetails.phone_number}</p>
        </div>
        <div>
          <p className="text-gray-600">Alternate Phone Number</p>
          <p className="font-semibold">{studentDetails.alternate_phone_number || 'N/A'}</p>
        </div>
        <div>
          <p className="text-gray-600">Gender</p>
          <p className="font-semibold">{studentDetails.gender || 'N/A'}</p>
        </div>
        <div>
          <p className="text-gray-600">Grade</p>
          <p className="font-semibold">{studentDetails.grade}</p>
        </div>
      </div>
    </div>
  );
}